import { color } from "@styles";
import { mobile, tablet } from "components/templates/Breakpoints";
import { StandardPadding } from "components/templates/StandardPadding";
import { StandardSection } from "components/templates/StandardSection";
import styled from "styled-components";
import Image from "next/image";
import { Flex } from "@yu-life/yulife-components-static";

export const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
`;

export const Stats = styled(StandardPadding)`
  padding-top: 7.5rem;
  padding-bottom: 10.5rem;
`;

export const ProductOverviewSection = styled.div`
  background: ${color.B210};
  padding-left: 3rem;
  padding-right: 3rem;
`;

export const ProductOverviewSectionCopy = styled(StandardSection)`
  padding-bottom: 3.5rem;
  background: ${color.B210};
  padding-top: 0rem;
`;

export const ProductCardsSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  row-gap: 2rem;
  flex-wrap: wrap;
  margin: 0 auto;
  padding-bottom: 4rem;
  max-width: 80rem;
  margin-bottom: 2rem;
`;

export const ButtonWrapper = styled.div`
  padding-bottom: 8rem;
  display: flex;
  justify-content: center;
`;

export const Img = styled(Image)`
  max-width: 34rem;
  border-radius: 0.5rem;

  ${tablet} {
    width: 100%;
  }
`;

export const StyledImg = styled(Image)<{ locale?: string }>`
  margin: 0 auto;
  padding: 1rem;
  width: 100%;
  height: auto;
  max-width: ${(p) => (p.locale === "us" ? "34rem" : "21rem")};

  ${mobile} {
    padding: 3rem;
    padding-bottom: 0rem;
  }
`;

export const LottieFile = styled.div`
  width: 30rem;
  max-width: 80vw;
}`;

export const CaseStudiesFlex = styled(Flex)`
  gap: 2rem;
  padding-bottom: 5rem;
  justify-content: center;

  @media only screen and (max-width: 60rem) {
    row-gap: 4rem;
  }

  ${mobile} {
    row-gap: 2rem;
    flex-direction: column;
  }
`;
